import { render, staticRenderFns } from "./NewFilesUploader.vue?vue&type=template&id=75a142a0"
import script from "./NewFilesUploader.vue?vue&type=script&lang=js"
export * from "./NewFilesUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports